import { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Register from './pages/Register'
import Login from './pages/Login'
import NotFound from './components/NotFound'
import Home from './pages/Home'

function App() {


    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Home />} />

                {/* Public Routes */}
                <Route path='/register' element={<Register />} />
                <Route path='/login' element={<Login />} />


                {/* Not Found */}
                <Route path='*' element={<NotFound />} />

            </Routes>
        </BrowserRouter>
    )
}

export default App